<div class="sidemenu-area">
    <div class="sidemenu-header">
        <div  class="d-flex justify-content-end">
            <div (click)="onToggleSidebar()" class="burger-menu d-none d-lg-block d-md-block">
                <span class="top-bar"></span>
                <span class="middle-bar"></span>
                <span class="bottom-bar"></span>
            </div>
        </div>

        <div class="d-flex justify-content-end">
            <div class="responsive-burger-menu d-block d-lg-none d-md-none text-end">
                <span class="top-bar"></span>
                <span class="middle-bar"></span>  
                <span class="bottom-bar"></span>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <a href="/dashboard" class="navbar-brand">
                       <div>
                        <div style="text-align: center; ">
                            <img style="max-width: 50%;" src="assets/img/logo_novo_fragmaq.jpeg" alt="image">   
                        </div>
                       </div>
                    </a>
                </div>                
            </div>            
        </div>
    </div>

    <div class="sidemenu-body">
        <ul class="sidemenu-nav metisMenu h-100" id="sidemenu-nav" data-simplebar>
            <app-loading *ngIf="isLoading"></app-loading>
            
            <div class="search-container" [style.display]="isCollapsed ? 'none' : 'block'">
                <input
                    type="text"
                    class="form-control"
                    placeholder="Pesquisar..."
                    [(ngModel)]="txtProcurarMenu"
                    (input)="filtrarMenu()"
                />
            </div>

            <!-- Renderização recursiva dos menus -->
            <!-- Primeiro Nível: Menus Principais (nivel = 1) -->
            <ng-container *ngFor="let menuPrincipal of getMenusPrincipais(); let menuPrincipalIndex = index">
                <!-- Só renderiza o menu principal se ativo e show forem true -->
                <li class="nav-item" *ngIf="menuPrincipal.ativo && menuPrincipal.show">
                    <a 
                        class="collapsed-nav-link nav-link"
                        [class.active]="menuPrincipal.expanded"
                        [attr.aria-expanded]="menuPrincipal.expanded"
                        (click)="toggleMenu(menuPrincipal)"
                        style="cursor: pointer;"
                    >
                        <span class="icon"><i [class]="getMenuIcon(menuPrincipal)"></i></span>
                        <span class="menu-title fw-bold">{{ menuPrincipal.nome }}</span>
                        <span class="badge-chamados margin-total-chamado" *ngIf="menuPrincipal.nome == 'CHAMADOS' && (totalMeusChamados + totalMinhasAprovacoes) > 0">{{ totalMeusChamados + totalMinhasAprovacoes }}</span>
                        <span class="badge-chamados margin-total-chamado" *ngIf="menuPrincipal.nome == 'SGI' && totalPendenciasSgiComSacpm > 0">{{ totalPendenciasSgiComSacpm }}</span>

                    </a>

                    <!-- Segundo Nível: Submenus (nivel = 2) -->
                    <ul class="sidemenu-nav-second-level" [class.show]="menuPrincipal.expanded" *ngIf="hasSubMenus(menuPrincipal)">
                        <ng-container *ngFor="let menu of menuPrincipal.subMenus; let subMenuIndex = index">
                            <!-- Só renderiza o submenu se ativo e show forem true -->
                            <li class="nav-item" *ngIf="menu.ativo && menu.show">
                                
                                <!-- Menu com submenus (nível 3) -->
                                <ng-container *ngIf="hasSubMenus(menu)">
                                    <a 
                                        class="collapsed-nav-link nav-link"
                                        [class.active]="menu.expanded"
                                        [attr.aria-expanded]="menu.expanded"
                                        (click)="toggleMenu(menu)"
                                        style="cursor: pointer;"
                                    >
                                        <span class="icon"><i [class]="getMenuIcon(menu)"></i></span>
                                        <span class="menu-title">{{ menu.nome }}</span>
                                        <span class="badge-chamados margin-minhas-pendencias" *ngIf="menu.nome == 'Inform. Documentada' && totalPendenciasSgi > 0">{{ totalPendenciasSgi }}</span>
                                        <span class="badge-chamados margin-minhas-pendencias" *ngIf="menu.nome == 'SACPM' && totalPendenciasSacpm > 0">{{ totalPendenciasSacpm }}</span>
                                        <span class="badge-chamados margin-minhas-pendencias" *ngIf="menu.nome == 'Gestão de Mudanças' && totalPendenciasGestaoMudanca > 0">{{ totalPendenciasGestaoMudanca }}</span>
                                    </a>

                                    <!-- Terceiro Nível: Submenus -->
                                    <ul class="sidemenu-nav-third-level" [class.show]="menu.expanded">
                                        <ng-container *ngFor="let subMenu of menu.subMenus">
                                            <!-- Só renderiza o submenu nível 3 se ativo e show forem true -->
                                            <li class="nav-item" *ngIf="subMenu.ativo && subMenu.show">
                                                
                                                <!-- Submenu com mais submenus (nível 4) -->
                                                <ng-container *ngIf="hasSubMenus(subMenu)">
                                                    <a 
                                                        class="collapsed-nav-link nav-link"
                                                        [class.active]="subMenu.expanded"
                                                        [attr.aria-expanded]="subMenu.expanded"
                                                        (click)="toggleMenu(subMenu)"
                                                        style="cursor: pointer;"
                                                    >
                                                        <span class="icon"><i [class]="getMenuIcon(subMenu)"></i></span>
                                                        <span class="menu-title">{{ subMenu.nome }}</span>
                                                    </a>

                                                    <!-- Quarto Nível: Submenus -->
                                                    <ul class="sidemenu-nav-fourth-level" [class.show]="subMenu.expanded">
                                                        <ng-container *ngFor="let subSubMenu of subMenu.subMenus">
                                                            <!-- Só renderiza o submenu nível 4 se ativo e show forem true -->
                                                            <li class="nav-item" *ngIf="subSubMenu.ativo && subSubMenu.show">
                                                                <a 
                                                                    class="nav-link"
                                                                    [class.active]="subSubMenu.active"
                                                                    (click)="navigateTo(subSubMenu.caminho)"
                                                                    style="cursor: pointer;"
                                                                >
                                                                    <span class="icon"><i [class]="getMenuIcon(subSubMenu)"></i></span>
                                                                    <span class="menu-title">{{ subSubMenu.nome }}</span>
                                                                </a>
                                                            </li>
                                                        </ng-container>
                                                    </ul>
                                                </ng-container>

                                                <!-- Submenu sem filhos (navegação direta) -->
                                                <ng-container *ngIf="!hasSubMenus(subMenu)">
                                                    <a 
                                                        class="nav-link"
                                                        [class.active]="subMenu.active"
                                                        (click)="navigateTo(subMenu.caminho)"
                                                        style="cursor: pointer;"
                                                    >
                                                        <span class="icon"><i [class]="getMenuIcon(subMenu)"></i></span>
                                                        <span class="menu-title">{{ subMenu.nome }}</span>
                                                        <span class="badge-chamados margin-total-chamado" *ngIf="subMenu.nome == 'Meus Atendimentos' && totalMeusChamados > 0">{{ totalMeusChamados }}</span>
                                                        <span class="badge-chamados margin-total-chamado-aprovacao" *ngIf="subMenu.nome == 'Minhas Aprovações' && totalMinhasAprovacoes > 0">{{ totalMinhasAprovacoes }}</span>
                                                        <span class="badge-chamados margin-total-chamado" *ngIf="subMenu.nome == 'Minhas Pendências SGI' && totalPendenciasSgi > 0">{{ totalPendenciasSgi }}</span>
                                                        <span class="badge-chamados margin-total-chamado" *ngIf="subMenu.nome == 'Minhas Pendências SACPM' && totalPendenciasSacpm > 0">{{ totalPendenciasSacpm }}</span>
                                                        <span class="badge-chamados margin-total-chamado" *ngIf="subMenu.nome == 'Minhas Pendências Gestão de Mudanças' && totalPendenciasGestaoMudanca > 0">{{ totalPendenciasGestaoMudanca }}</span>
                                                    </a>
                                                </ng-container>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </ng-container>

                                <!-- Menu sem submenus (navegação direta) -->
                                <ng-container *ngIf="!hasSubMenus(menu)">
                                    <a 
                                        class="nav-link"
                                        [class.active]="menu.active"
                                        (click)="navigateTo(menu.caminho)"
                                        style="cursor: pointer;"
                                    >
                                        <span class="icon"><i [class]="getMenuIcon(menu)"></i></span>
                                        <span class="menu-title">{{ menu.nome }}</span>
                                    </a>
                                </ng-container>
                            </li>
                        </ng-container>
                    </ul>
                </li>
            </ng-container>

            <!-- Mensagem quando não há menus ou resultados de pesquisa -->
            <li *ngIf="!isLoading && menusFiltrados.length === 0" class="nav-item">
                <div class="text-center p-3 text-muted">
                    <i class="bx bx-info-circle"></i>
                    <p class="mt-2">
                        <span *ngIf="txtProcurarMenu">Nenhum menu encontrado para "{{ txtProcurarMenu }}"</span>
                        <span *ngIf="!txtProcurarMenu">Nenhum menu disponível</span>
                    </p>
                </div>
            </li>
        </ul>
    </div>
</div>